import { render } from "./TruncTooltip.vue?vue&type=template&id=0d3a2514"
import script from "./TruncTooltip.vue?vue&type=script&lang=js"
export * from "./TruncTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__